// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__dLDuQ {
  padding: 1rem;
}

.styles_header__Yxybz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.styles_title__isusa {
  color: #18316e;
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
}

.styles_loadingContainer__ZzMUT {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.styles_versoesList__KKdf6 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.styles_versaoItem__XVX1A {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: white;
}

.styles_versaoInfo__vhq07 {
  flex: 1 1;
}

.styles_versaoTitulo__R4is2 {
  margin: 0 0 0.5rem 0;
  color: #18316e;
  font-size: 1.1rem;
  font-weight: 600;
}

.styles_versaoData__VLrcJ {
  margin: 0;
  color: #666;
  font-size: 0.9rem;
}

.styles_versaoActions__DgqHL {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.styles_motorProgress__800Lj {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.2);
}

.styles_motorProgressContent__NKRg\\+ {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.styles_motorProgressSpinner__haXo1 {
  width: 20px;
  height: 20px;
  border: 2px solid #ffc107;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: styles_spin__0b7mq 1s linear infinite;
}

.styles_motorProgressText__t7TD0 {
  color: #856404;
  font-weight: 500;
  font-size: 0.9rem;
}

@keyframes styles_spin__0b7mq {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.styles_novaVersaoContainer__SDdku {
  padding: 1rem;
}

.styles_novaVersaoTitulo__VosWi {
  margin: 0 0 1rem 0;
  color: #18316e;
  font-size: 1.2rem;
  font-weight: 600;
}

.styles_novaVersaoActions__uWbM\\+ {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}

/* Estilos legados para compatibilidade */
.styles_containerTitle__KBdDH {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.styles_containerVersao__OFMDL {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_itemVersao__PUAuW {
  align-items: center;
  border-radius: 5px;
  box-shadow: 1px 1px 5px #c6c6c6;
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0.6rem;
}

.styles_containerBtn__IFcOy {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

.styles_btnAnalisar__XZTcY {
  background: #18316e !important;
}

.styles_btnAnalisar__XZTcY:hover {
  background: #204091 !important;
}

.styles_btnFechar__U4rL2 {
  border-color: #18316e !important;
  color: #18316e !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Previa/ModalVersoes/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,gDAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B","sourcesContent":[".container {\n  padding: 1rem;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.title {\n  color: #18316e;\n  font-size: 1.5rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n}\n\n.versoesList {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.versaoItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background: white;\n}\n\n.versaoInfo {\n  flex: 1;\n}\n\n.versaoTitulo {\n  margin: 0 0 0.5rem 0;\n  color: #18316e;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.versaoData {\n  margin: 0;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.versaoActions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.motorProgress {\n  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);\n  border: 1px solid #ffc107;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.2);\n}\n\n.motorProgressContent {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.motorProgressSpinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #ffc107;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.motorProgressText {\n  color: #856404;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.novaVersaoContainer {\n  padding: 1rem;\n}\n\n.novaVersaoTitulo {\n  margin: 0 0 1rem 0;\n  color: #18316e;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.novaVersaoActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n/* Estilos legados para compatibilidade */\n.containerTitle {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n\n.containerVersao {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.itemVersao {\n  align-items: center;\n  border-radius: 5px;\n  box-shadow: 1px 1px 5px #c6c6c6;\n  display: flex;\n  justify-content: space-between;\n  padding: 0.3rem 0.6rem;\n}\n\n.containerBtn {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n}\n\n.btnAnalisar {\n  background: #18316e !important;\n}\n\n.btnAnalisar:hover {\n  background: #204091 !important;\n}\n\n.btnFechar {\n  border-color: #18316e !important;\n  color: #18316e !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__dLDuQ`,
	"header": `styles_header__Yxybz`,
	"title": `styles_title__isusa`,
	"loadingContainer": `styles_loadingContainer__ZzMUT`,
	"versoesList": `styles_versoesList__KKdf6`,
	"versaoItem": `styles_versaoItem__XVX1A`,
	"versaoInfo": `styles_versaoInfo__vhq07`,
	"versaoTitulo": `styles_versaoTitulo__R4is2`,
	"versaoData": `styles_versaoData__VLrcJ`,
	"versaoActions": `styles_versaoActions__DgqHL`,
	"motorProgress": `styles_motorProgress__800Lj`,
	"motorProgressContent": `styles_motorProgressContent__NKRg+`,
	"motorProgressSpinner": `styles_motorProgressSpinner__haXo1`,
	"spin": `styles_spin__0b7mq`,
	"motorProgressText": `styles_motorProgressText__t7TD0`,
	"novaVersaoContainer": `styles_novaVersaoContainer__SDdku`,
	"novaVersaoTitulo": `styles_novaVersaoTitulo__VosWi`,
	"novaVersaoActions": `styles_novaVersaoActions__uWbM+`,
	"containerTitle": `styles_containerTitle__KBdDH`,
	"containerVersao": `styles_containerVersao__OFMDL`,
	"itemVersao": `styles_itemVersao__PUAuW`,
	"containerBtn": `styles_containerBtn__IFcOy`,
	"btnAnalisar": `styles_btnAnalisar__XZTcY`,
	"btnFechar": `styles_btnFechar__U4rL2`
};
export default ___CSS_LOADER_EXPORT___;
